import core from "./core";

const ruleTypes = ["Hindrance", "Edge"];
const ruleTypesPlural = { Hindrance: "Hindrances", Edge: "Edges" };

const rankOptions = ["Novice", "Seasoned", "Veteran", "Heroic", "Legenary"];

const advancementChart = [
  { rank: "Novice", experience: 0, next: 20 },
  { rank: "Seasoned", experience: 20, next: 40 },
  { rank: "Veteran", experience: 40, next: 60 },
  { rank: "Heroic", experience: 60, next: 80 },
  { rank: "Legenary", experience: 80, next: 999999 }
];

const diceOptions = [
  { text: "1d4", value: 4 },
  { text: "1d6", value: 6 },
  { text: "1d8", value: 8 },
  { text: "1d10", value: 10 },
  { text: "1d12", value: 12 }
];

const getAdvancement = exp => {
  let advancement;
  advancement = advancementChart.find(x => x.experience <= exp && x.next > exp);
  advancement = advancement || advancementChart[0];
  return advancement;
};

const getRank = exp => {
  let advancement = getAdvancement(exp);
  let rank = advancement ? advancement.rank : "Novice";
  return rank;
};

const getDescriptor = entity => {
  let race = entity.race || "";
  let klass = entity.class || "";
  let level = getRank(entity.experience);

  let description =
    entity.race || klass ? `${level} ${race} ${klass}`.trim() : "Peasant";

  return description;
};


const health = payload => {
  payload = payload || {};

  if (payload.dead) {
    return "dead";
  }

  return "full";
};


const isDead = entity => {
  let payload = {
    dead: entity.dead || false,
  };
  let status = health(payload);
  return status === "dead";
};

const getAttackBonus = payload => {
  if (payload.skill && payload.attack) {
    let dice = payload.skill.score == 0 ? "1d4" : `1d${payload.skill.score}`; /// 1d0, 1d4, 1d6
    let bonus = payload.health.wounds + payload.health.fatigue;
    bonus =
      payload.attack.misc && isFinite(payload.attack.misc)
        ? bonus + parseInt(payload.attack.misc, 10)
        : bonus;
    bonus =
      payload.attack.magic && isFinite(payload.attack.magic)
        ? bonus + parseInt(payload.attack.magic, 10)
        : bonus;
    bonus = payload.skill.score == 0 ? -2 + bonus : bonus;
    bonus = bonus < 0 ? `${bonus}` : `+${bonus}`;
    dice = bonus === "+0" ? dice : dice + bonus;
    return dice;
  } else {
    return null;
  }
};

const getDamageBonus = payload => {
  let damage = payload.damage;
  let attribute = payload.attribute;

  if (damage) {
    let bonus = 0;
    bonus +=
      attribute && Number.isInteger(attribute.misc)
        ? parseInt(attribute.misc, 10)
        : 0;
    bonus +=
      damage && Number.isInteger(damage.misc) ? parseInt(damage.misc, 10) : 0;
    bonus +=
      damage && Number.isInteger(damage.magic) ? parseInt(damage.magic, 10) : 0;

    let plusMinus = bonus > -1 ? "+" : "";

    bonus =
      attribute && attribute.score
        ? `+1d${attribute.score}${plusMinus}${bonus}`
        : bonus;

    if (bonus) bonus = bonus.replace("+0", "");
    return bonus;
  }
};

const getCarriedWeight = items => {
  let itemWeights = [];
  items.filter(x => x.carried).forEach(item => {
    let quantity = item.quantity && isFinite(item.quantity) ? item.quantity : 0;
    let weight = item.quantity && isFinite(item.weight) ? item.weight : 0;
    if (quantity > 0 && weight > 0) itemWeights.push(quantity * weight);
  });
  var totalWeight = itemWeights.reduce((prevVal, val) => {
    return parseFloat(prevVal) + parseFloat(val);
  }, 0);

  let fixedFloat = totalWeight.toFixed(1);
  fixedFloat = fixedFloat.endsWith(".0")
    ? fixedFloat.replace(".0", "")
    : fixedFloat;
  return fixedFloat;
};

const getSpellBonus = (proficiencyBonus, attribute) => {
  let bonus = 0;
  if (proficiencyBonus) bonus += proficiencyBonus;
  if (attribute) bonus += core.getAttributeBonus(attribute);

  return bonus;
};

const getActionTypes = () => {
  let actionTypes = core.actionTypes;
  return actionTypes;
};

const getItemTypes = () => {
  let itemTypes = core.itemTypes.slice();
  itemTypes.push("Tool");
  return itemTypes;
};

const getTotalHitPoints = () => {
  return 0;
};

const attributeOptions = () => {
  let core = ["Agility", "Smarts", "Strength", "Spirit", "Vigor"];
  let options = [];
  core.forEach(function (element) {
    options.push({ text: element, value: element.toLowerCase() });
  });
  return options;
};

const ruleset = {
  getRank: getRank,
  getDescriptor: getDescriptor,
  getAttackBonus: getAttackBonus,
  getDamageBonus: getDamageBonus,
  getCarriedWeight: getCarriedWeight,
  getSpellBonus: getSpellBonus,

  getActionTypes: getActionTypes,
  getItemTypes: getItemTypes,

  getAttribute: core.getAttribute,
  getAttributeBonus: core.getAttributeBonus,
  getTotalHitPoints: getTotalHitPoints,

  ruleTypes: ruleTypes,
  ruleTypesPlural: ruleTypesPlural,

  diceOptions: diceOptions,
  attributeOptions: attributeOptions,
  rankOptions: rankOptions,

  health: health,
  isDead: isDead
};

export default ruleset;
